import { DateField, NumberField } from "react-admin"
import { XmlInvoiceDto } from "../GeneratedClients/FreeBillApi"
import { Box, Table, TableBody, TableRow, TableCell, Typography, Divider } from "@mui/material"

const XmlViewer = ({xmlInvoice, file}: {xmlInvoice?: XmlInvoiceDto, file?: File}) => {
  return (
    <Box>
      <Typography><strong>{file?.name ? file.name : "Bitte lade eine Rechnung hoch."}</strong></Typography>
      <Divider sx={{my:2}} />
      {
        file && !xmlInvoice &&
        <Typography>{`Die Datei ${file.name} hat keinen Xml-Anhang.`}</Typography>
      }
      {
        xmlInvoice &&
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell colSpan={2} sx={{fontWeight:"bold"}}>Rechnungsinfos</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Rechnungsnummer</TableCell>
              <TableCell>{xmlInvoice?.invoiceNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Rechnungsdatum</TableCell>
              <TableCell>
                <DateField record={xmlInvoice} source="invoiceDate" />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} sx={{fontWeight:"bold"}}>Verkäufer</TableCell>
            </TableRow>          
            <TableRow>
              <TableCell>Firma</TableCell>
              <TableCell>
                {xmlInvoice?.issuer?.company?.companyName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} sx={{fontWeight:"bold"}}>Käufer</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Firma</TableCell>
              <TableCell colSpan={4}>
                {xmlInvoice?.recipient?.company?.companyName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={5} sx={{fontWeight:"bold"}}>Rechnungsposten</TableCell>
            </TableRow>
            {
              xmlInvoice?.items?.map(tradeLineItem => (
                <TableRow>
                  <TableCell>{tradeLineItem.quantity}</TableCell>
                  <TableCell>{tradeLineItem.name}</TableCell>
                  <TableCell>
                    <NumberField record={tradeLineItem} source="price" options={{ style: 'currency', currency: 'EUR' }} />               
                  </TableCell>
                  <TableCell>
                    <NumberField record={tradeLineItem} source="taxInPercent" options={{ style: 'percent'}} transform={(x:number) => x/100} />               
                  </TableCell>
                  <TableCell>
                    <NumberField record={tradeLineItem} source="lineTotalAmount" options={{ style: 'currency', currency: 'EUR' }} />               
                  </TableCell>
                </TableRow>
              ))
            }
            <TableRow>
              <TableCell colSpan={2} sx={{borderBottom:"0px"}}></TableCell>
              <TableCell sx={{fontWeight:"bold"}}>USt</TableCell>
              <TableCell sx={{fontWeight:"bold"}}>Betrag [net]</TableCell>
              <TableCell sx={{fontWeight:"bold"}}>Betrag USt</TableCell>
            </TableRow>
            {
              xmlInvoice?.taxes?.map(tax => (
                <TableRow>
                  <TableCell colSpan={2} sx={{borderBottom:"0px"}}></TableCell>
                  <TableCell>
                    <NumberField record={tax} source="taxInPercent" options={{ style: 'percent'}} transform={(x:number) => x/100} />               
                  </TableCell>
                  <TableCell>
                    <NumberField record={tax} source="netBasisAmount" options={{ style: 'currency', currency: 'EUR' }} />               
                  </TableCell>
                  <TableCell colSpan={3}>
                    <NumberField record={tax} source="taxAmount" options={{ style: 'currency', currency: 'EUR' }} />               
                  </TableCell>
                </TableRow>
              ))
            }
            <TableRow>
              <TableCell colSpan={2} sx={{borderBottom:"0px"}}></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <NumberField sx={{fontWeight:"bold"}} record={xmlInvoice} source="netAmount" options={{ style: 'currency', currency: 'EUR' }} />               
              </TableCell>
              <TableCell>
                <NumberField sx={{fontWeight:"bold"}} record={xmlInvoice} source="taxAmount" options={{ style: 'currency', currency: 'EUR' }} />               
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      }
    </Box>
  )
}

export default XmlViewer